export const createRequestParams = (paramMap) => {
    let separator;
    let returnString = "";

    if (paramMap) {
        for (let i = 0; i <= paramMap.length - 1; i++) {
            if (paramMap.at(i).value) {
                if (returnString.includes("?")) separator = "&"
                else separator = "?";
                returnString += separator + paramMap.at(i).name + "=" + encodeURIComponent(paramMap.at(i).value);
            }
        }
    }
    
    return returnString;
}

export const concatenateStrings = (strings) => {
    return strings.join('');
}

export const toProperCase = (string) => {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

// Returns whether specified search term(s) can be found inside a JSON object.
export function isMatching(obj, searchString) {
    let isMatching = true;
    
    // Searching by multiple search terms separated by a space.
    if (searchString.includes(' ')) {
        let searchTerms = searchString.split(" ");
        // Loop through each search term and attempt to match against a value in the object.
        searchTerms.forEach(searchTerm => {
            // Continue attempting to match search terms as long as isMatching remains true.
            if (isMatching) {
                let searchTermMatched = false;

                // If the search term is found in the object then mark this as matched. 
                for (const [key, value] of Object.entries(obj)) {
                    if ((String(value)).toLowerCase().includes(searchTerm.toLowerCase())) {
                        searchTermMatched = true;
                    }
                }

                // If the search term is not found, mark isMatching as false to prevent any further matching.
                if (!searchTermMatched) {    
                    isMatching = false;
                }
            }
        });
    } else {
        // Searching by a single search term.
        isMatching = false;
        for (const [key, value] of Object.entries(obj)) {
            if ((String(value).toLowerCase()).includes(searchString.toLowerCase())) {
                isMatching = true;
            }
        }
    }

    return isMatching;
}